import { defineStore } from 'pinia'
import { i18n } from '@/libs/i18n'
import moment from 'moment'

export const usePreferences = defineStore('preferences', {
  state: () => ({
    walletsView: 'grid',
    locale: 'en',
  }),
  persist: {
    storage: localStorage,
    paths: ['walletsView', 'locale'],
  },
  actions: {
    setLocale(locale) {
      this.locale = locale
      moment.locale(locale)
      i18n.global.locale.value = locale
    },
    initCrossTabSync() {
      window.addEventListener('storage', (e) => {
        if (e.key !== 'preferences') return
        try {
          const data = JSON.parse(e.newValue)
          if (data.locale && data.locale !== this.locale) {
            this.setLocale(data.locale)
          }
        } catch (err) {
          console.warn('Failed to parse preferences from storage', err)
        }
      })
    },
  },
})
